export const UTILITY_GETTERS = Object.freeze({
    GET_LOCAL_UPTIME: "getLocalUptime"
});
